import { createGlobalStyle } from 'styled-components';
import img from './lain1.jpg';

const PracticeStyle = createGlobalStyle`
body {
  background: url(${img}) no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, sans-serif;
  background-color: #0a0a0a;
  color: #ff1493;
  font-size: 18px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
}

#root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

/* Practice Main Container */
.practice-main {
  flex: 1;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.practice-container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  animation: fadein 1s ease-in-out;
}

/* Practice Card - Pink Cyberpunk */
.practice-card {
  display: inline-block;
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(20, 10, 20, 0.75) 0%, rgba(40, 20, 40, 0.75) 100%);
  border: 2px solid #ff1493;
  border-radius: 10px;
  box-shadow: 20px 20px 20px rgba(255, 20, 147, 0.3), 10px 10px 20px rgba(255, 105, 180, 0.3);
  animation: electricbox 0.8s infinite, shadow-move-pink 4s infinite alternate;
  transition: box-shadow 0.3s ease-in-out;
  backdrop-filter: blur(5px);
  position: relative;
  overflow: hidden;
  text-align: center;
}

.practice-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 2px,
    rgba(255, 20, 147, 0.03) 2px,
    rgba(255, 20, 147, 0.03) 4px
  );
  animation: scan 10s linear infinite;
  pointer-events: none;
}

@keyframes scan {
  0% { transform: translateY(0); }
  100% { transform: translateY(50%); }
}

.practice-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 40px rgba(255, 20, 147, 0.6), inset 0 0 30px rgba(255, 20, 147, 0.2);
  border-color: #ff69b4;
}

h1 {
  color: #ff1493;
  font-size: 2.5rem;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 1rem;
  text-shadow: 0 0 10px rgba(255, 20, 147, 0.8), 0 0 20px rgba(255, 20, 147, 0.4);
  position: relative;
  z-index: 1;
}

h2 {
  color: #ff69b4;
  font-size: 1.1rem;
  font-weight: normal;
  margin-top: 0;
  margin-bottom: 2rem;
  line-height: 1.6;
  text-shadow: 0 0 5px rgba(255, 105, 180, 0.5);
  position: relative;
  z-index: 1;
}

#f1 {
  text-align: center;
  position: relative;
  z-index: 1;
}

label {
  display: block;
  color: #ff1493;
  text-shadow: 0 0 10px rgba(255, 20, 147, 0.6);
  font-size: 1.25rem;
  font-weight: bold;
  margin: 1.5rem 0 0.75rem;
  text-align: center;
  cursor: pointer;
}

input[type="radio"] {
  margin: 10px;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  accent-color: #ff1493;
}

label input[type="radio"]:checked + span {
  text-decoration: underline;
  color: #ff1493;
  transition: all 0.3s ease-in-out;
  transform: scale(1.1);
  animation: electric 0.8s infinite;
}

input[type="radio"]:hover {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(255, 20, 147, 0.5);
  animation: electric 0.8s infinite;
  cursor: pointer;
}

label span {
  color: #ff69b4;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

label:hover span {
  color: #ff1493;
  text-shadow: 0 0 10px rgba(255, 20, 147, 0.8);
}

input[type="number"] {
  display: block;
  height: auto;
  width: 80px;
  margin: 1rem auto;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.6);
  border: 2px solid #ff1493;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(255, 20, 147, 0.3);
  transition: all 0.3s ease-in-out;
  color: #ff69b4;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
}

input[type="number"]:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px rgba(255, 20, 147, 0.5);
  border-color: #ff69b4;
}

input[type="number"]:focus {
  outline: none;
  border-color: #ff69b4;
  box-shadow: 0 0 30px rgba(255, 20, 147, 0.6);
  animation: electric 0.8s infinite;
}

input[type="submit"] {
  display: block;
  margin: 2rem auto 0;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #ff1493 0%, #ff69b4 100%);
  color: #000;
  border: 2px solid #ff69b4;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(255, 20, 147, 0.4);
  transition: all 0.3s ease-in-out;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

input[type="submit"]:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 40px rgba(255, 20, 147, 0.8), inset 0 0 20px rgba(255, 20, 147, 0.3);
  animation: electric 0.8s infinite;
  background: linear-gradient(135deg, #ff69b4 0%, #ff1493 100%);
}

/* Animations */
@keyframes electric {
  0% {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    filter: drop-shadow(0 0 5px currentColor);
  }
  50% {
    text-shadow: 0 0 10px currentColor, 0 0 20px currentColor;
    filter: drop-shadow(0 0 15px currentColor);
  }
  100% {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    filter: drop-shadow(0 0 5px currentColor);
  }
}

@keyframes electricbox {
  0% {
    box-shadow: 0 0 10px rgba(255, 20, 147, 0.3), inset 0 0 10px rgba(255, 20, 147, 0.1);
  }
  50% {
    box-shadow: 0 0 30px rgba(255, 20, 147, 0.6), inset 0 0 20px rgba(255, 20, 147, 0.2);
  }
  100% {
    box-shadow: 0 0 10px rgba(255, 20, 147, 0.3), inset 0 0 10px rgba(255, 20, 147, 0.1);
  }
}

@keyframes shadow-move-pink {
  0% {
    box-shadow: 0 0 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
  }
  25% {
    box-shadow: 10px 10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
  }
  50% {
    box-shadow: 20px 10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
  }
  75% {
    box-shadow: -10px -10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
  }
  100% {
    box-shadow: -10px -10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
  }
}

@keyframes fadein {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Nav Menu Hover Effects - Practice Page Specific */
nav ul li a, nav ul li button {
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
  color: #ff1493;
  text-shadow: 1px 1px 2px #ff1493, 0 0 1em #ff1493, 0 0 0.2em #ff69b4;
  transition: text-shadow 0.3s ease;
  animation: electric 0.8s infinite;
}

nav ul li button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
  margin-top: auto;
  height: 60px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  flex-shrink: 0;
} */

/* Responsive Design */
@media (max-width: 768px) {
  body {
    font-size: 14px !important;
  }

  .practice-main {
    padding: 1rem 0.75rem !important;
  }

  .practice-card {
    padding: 1.25rem !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  h1 {
    font-size: 1.5rem !important;
    margin-bottom: 0.75rem !important;
  }

  h2 {
    font-size: 0.875rem !important;
    margin-bottom: 1.5rem !important;
    line-height: 1.4 !important;
  }

  label {
    font-size: 0.95rem !important;
    margin: 1rem 0 0.5rem !important;
  }

  label span {
    font-size: 0.9rem !important;
  }

  input[type="number"] {
    width: 60px !important;
    padding: 0.5rem !important;
    font-size: 1rem !important;
  }

  input[type="submit"] {
    font-size: 0.875rem !important;
    padding: 0.75rem 1.25rem !important;
    width: 100% !important;
    max-width: 280px !important;
  }

  input[type="radio"] {
    margin: 6px !important;
  }

  footer {
    font-size: 14px !important;
    padding: 15px 10px 0 !important;
    height: auto !important;
    min-height: 50px !important;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 13px !important;
  }

  .practice-main {
    padding: 0.75rem 0.5rem !important;
  }

  .practice-card {
    padding: 1rem !important;
  }

  h1 {
    font-size: 1.25rem !important;
  }

  h2 {
    font-size: 0.8rem !important;
    line-height: 1.3 !important;
  }

  label {
    font-size: 0.875rem !important;
    margin: 0.875rem 0 0.4rem !important;
  }

  label span {
    font-size: 0.85rem !important;
  }

  input[type="number"] {
    width: 55px !important;
    padding: 0.45rem !important;
    font-size: 0.95rem !important;
  }

  input[type="submit"] {
    font-size: 0.8rem !important;
    padding: 0.65rem 1rem !important;
  }

  footer {
    font-size: 13px !important;
    padding: 12px 8px 0 !important;
  }
}
`;

export default PracticeStyle;